export default {
    tagged: '4.0.3-3671c03',
    version: '4.0.3',
    revision: '3671c03',
};
//# sourceMappingURL=version.js.map